module.exports = __webpack_public_path__ + "img/undraw_Upload_re_pasx.a6ad32f0.svg";